/* * @Author: ligai  */
const lineType = {
  // 采购行详情
  getById: {
    url: `/purchaser/general/lineType/getByCode/share/component`,
    type: 'post'
  }
}
export default lineType
